const memoryChapterMapper = {
    toDomain(data) {
        return {
            id: data.chapter,
            label: data.title,
            answerCount: data.answerCount,
            answersUntilMemory: data.answersUntilMemory,
            isMemoryUnlocked: Boolean(data.isMemoryUnlocked),
            isMemoryPending: Boolean(data.isMemoryPending),
            isInitial: Boolean(data.isInitial)
        };
    }
};

export {
    memoryChapterMapper
};
